import { render, staticRenderFns } from "./activitiesDetail2023tj.vue?vue&type=template&id=4c06dc1e&scoped=true"
import script from "./activitiesDetail2023tj.vue?vue&type=script&lang=js"
export * from "./activitiesDetail2023tj.vue?vue&type=script&lang=js"
import style0 from "./activitiesDetail2023tj.vue?vue&type=style&index=0&id=4c06dc1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c06dc1e",
  null
  
)

export default component.exports